export default __webpack_public_path__ + "static/media/nextarrow.33259179.svg";